module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21.4 13.8c.9-1.2 1.4-2.6 1.4-4.2 0-3.9-3.2-7-7.1-7-3.9 0-7.1 3.1-7.1 7s3.2 7 7.1 7c1.4 0 2.7-.4 3.9-1.1 0 0 5.9 5.7 6.1 6 1.9.2 1.8-1.8 1.8-1.8l-6.1-5.9zM9.7 9.6c0-3.3 2.7-5.9 6.1-5.9 3.3 0 6.1 2.7 6.1 5.9 0 3.3-2.7 5.9-6.1 5.9-3.4 0-6.1-2.7-6.1-5.9z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.9 8.5h-6.4c-.4 0-.8.4-.8.8v1c0 .4.4.8.8.8h6.4c.4 0 .8-.4.8-.8v-1c0-.4-.3-.8-.8-.8z","fill":"#fff"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/zoom_out.svg
// module id = 729
// module chunks = 2